import { observer } from 'mobx-react-lite';
import { FC, useLayoutEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { setIsUnauthorizedView } from '@gem/call/Model/callModel';
import { PopupManager, Toast } from '@gem/popups';

import { GetParametersManager } from 'APP/main/Popups/GetParametersManager/GetParametersManager';
import { CallPreview as CallPreviewPage } from 'APP/unauthorized/CallPreview/CallPreview';
import { CallFinishedPage } from 'APP/unauthorized/Pages/CallFinishedPage';

import { CallInvitationLinkAccessDisabledPage } from '../unauthorized/Pages/CallInvitationLinkAccessDisabledPage';
import { CallInvitationLinkExpiredPage } from '../unauthorized/Pages/CallInvitationLinkExpiredPage';
import { CallInvitationPage } from '../unauthorized/Pages/CallInvitationPage';
import { CallInvitationLoginPage } from './Pages/CallInvitationLoginPage';
import { UnauthorizedRouts } from './UnauthorizedView.constants';
import styles from './UnauthorizedView.styles.m.css';

export const UnauthorizedView: FC = observer(() => {
  useLayoutEffect(() => {
    setIsUnauthorizedView(true);

    return () => {
      setIsUnauthorizedView(false);
    };
  }, []);

  return (
    <>
      <div className={styles.container}>
        <Routes>
          <Route
            path={`${UnauthorizedRouts.CallInvitation}`}
            element={<CallInvitationPage />}
          />
          <Route
            path={`${UnauthorizedRouts.CallInvitationLinkExpired}`}
            element={<CallInvitationLinkExpiredPage />}
          />
          <Route
            path={`${UnauthorizedRouts.CallInvitationAccessDisabled}`}
            element={<CallInvitationLinkAccessDisabledPage />}
          />
          <Route
            path={`${UnauthorizedRouts.CallInvitationLogin}`}
            element={<CallInvitationLoginPage />}
          />
          <Route
            path={UnauthorizedRouts.CallFinished}
            element={<CallFinishedPage />}
          />
          <Route
            path={UnauthorizedRouts.CallPreview}
            element={<CallPreviewPage />}
          />
        </Routes>
      </div>
      <PopupManager />
      <Toast />
      <GetParametersManager />
    </>
  );
});
